import { lazy } from 'react';
import PrivateRoute from '../../components/common/Router/PrivateRoute/PrivateRoute';

const MiembroProfile = lazy(() => import('./MiembroProfile'));

const ProfileRoutes = [
  {
    path: 'perfil/*',
    element: (
      <PrivateRoute
        allowedRoles={['admin', 'miembro']}
        component={MiembroProfile}
      />
    ),
  },
];

export default ProfileRoutes;
